import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SvcPostPublic, setSession } from "../services/userService";
import { toast } from "react-toastify";

function Login() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const validate = (name, value) => {
    switch (name) {
      case "email":
        return /\S+@\S+\.\S+/.test(value);
      case "password":
        return value.length >= 6;
      default:
        return true;
    }
  };

  const handleChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
    setTouched({ ...touched, [name]: true });
    setErrors({ ...errors, [name]: !validate(name, value) });
  };

  const getInputClass = (name) => {
    if (!touched[name]) return "reg-input";
    return `reg-input ${errors[name] ? "input-error" : "input-success"}`;
  };

  const getIcon = (name) => {
    if (!touched[name]) return null;
    return errors[name] ? (
      <span className="material-symbols-outlined status-icon error">error</span>
    ) : (
      <span className="material-symbols-outlined status-icon success">check_circle</span>
    );
  };

  const isFormValid = () => {
    return Object.keys(formData).every((k) => validate(k, formData[k]));
  };

  const handleSubmit = () => {
    if (!isFormValid()) {
      toast.error("Please correct all fields");
      return;
    }

    SvcPostPublic("/users/login", formData)
      .then((res) => {
        toast.success("Login successful!");

        if (res.data?.token && res.data?._id) {
          setSession({
            token: res.data.token,
            _id: res.data._id
          });
        }

        navigate("/wellness-guidance", { replace: true });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Login failed");
      });
  };

  return (
    <section className="reg-section">
      <div className="reg-card">
        {/* Header */}
        <header className="reg-header">
          <div className="back-btn" onClick={() => navigate(-1)}>
            <span className="material-symbols-outlined">arrow_back</span>
          </div>
          <h1 className="header-text">Log In</h1>
          <div className="header-spacer"></div>
        </header>

        {/* Progress — hidden for login */}
        <div className="progress-bar" style={{ opacity: 0 }}>
          <div className="progress-dot"></div>
          <div className="progress-dot"></div>
          <div className="progress-dot"></div>
        </div>

        {/* Main */}
        <main className="reg-main">
          <h2 className="reg-title">Welcome Back</h2>
          <p className="reg-subtitle">Enter your login details.</p>

          {/* EMAIL */}
          <div className="form-group">
            <label className="form-label">Email</label>
            <div className="input-wrapper">
              <input
                type="email"
                className={getInputClass("email")}
                placeholder="Enter your email"
                value={formData.email}
                onChange={(e) => handleChange("email", e.target.value)}
              />
              {getIcon("email")}
            </div>
          </div>

          {/* PASSWORD */}
          <div className="form-group">
            <label className="form-label">Password</label>
            <div className="input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                className={getInputClass("password")}
                placeholder="Enter password"
                value={formData.password}
                onChange={(e) => handleChange("password", e.target.value)}
              />
              <span
                className="material-symbols-outlined password-toggle-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? "visibility_off" : "visibility"}
              </span>
              {getIcon("password")}
            </div>
          </div>
        </main>

        <footer className="reg-footer">
          <button
            className={`submit-btn ${isFormValid() ? "active" : ""}`}
            disabled={!isFormValid()}
            onClick={handleSubmit}
          >
            Log In
          </button>

          <p className="login-text">
            Don't have an account?{" "}
            <span onClick={() => navigate("/registration")}>
              Register Now
            </span>
          </p>
        </footer>
      </div>
    </section>
  );
}

export default Login;
